module.exports = __webpack_public_path__ + "img/elwinsharvill.b3badeed.png";